<template>
  <div id="app">
    <div
      :class="$route.meta.isShow ? 'main-app-css' : ''"
      :style="$route.name==='educateFront'||$route.name==='Medical'?'min-width: 1300px;overflow-x: hidden':'min-width: 1300px'"
   
    >
      <div class="navbar-app-css" v-show="$route.meta.isShow">
        <NavBar></NavBar>
      </div>
      <div class="router-view-css">
        <TopBar v-show="$route.meta.isShow"></TopBar>
      
        <keep-alive :include="keepAliveArr">
          <router-view></router-view>
        </keep-alive>
        <Footer v-show="$route.meta.isShow"></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import Footer from "./components/Footer.vue";
import TopBar from "./components/TopBar.vue";
import router from "./router";
const defaultAddKeepArr = [
  "medicalAdminInstitutionJobCreation1",
  "medicalAdminInstitutionJobCreation2"
];
const defaultDetailKeepArr = [
  "medicalInstitutionJobRevise1",
  "medicalInstitutionJobRevise2"
];

const defaultAddEducationKeepArr = [
  "educationAdminTalentAdd1",
  "educationAdminTalentAdd2"
];
const defaultEducationKeepArr = [
  "userEducationInstitutionsToModifyTheSchedule1",
  "userEducationInstitutionsToModifyTheSchedule2"
];
const defaultEducationTalentKeepArr = [
  "educationTalentAdd1",
  "educationTalentAdd2"
];
const defaultAdminTalentAddKeepArr = [
  "adminTalentAdd1",
  "adminTalentAdd2"
];
const defaultAdminPostAddPageProgressKeepArr = [
  "adminPostAddPageProgressOne",
  "adminPostAddPageProgressTwo"
];
const defaultadminJobRevise1KeepArr=['adminJobRevise1','adminJobRevise2']
const educationalInstitutionTalentRevisionProgress=[
  'educationalInstitutionTalentRevisionProgress1',
  'educationalInstitutionTalentRevisionProgress2'
]

export default {
  name: "App",
  components: { NavBar, Footer, TopBar },
  created() {},
  data() {
    return {
      keepAliveArr: defaultAddKeepArr
    };
  },
  mounted() {
    console.log(this.$route==='educateFront')
    router.beforeEach((to, from, next) => {
      console.log(to.path == "/educationAdminTalentAddOne");
      if (
        to.path ==
          "/administratorMedicalInstitutionRequestingCasesViewManagementList" ||
        to.path == "/educationalInstitutionTalentListView" ||
        to.path == "/userEducationalInstitutionTalentListView"||to.path=='/adminTalentManagement'|| to.path=='administratorCaseManagement'|| to.path=='/adminTalentManagement'
      ) {
        this.keepAliveArr = [];
      }
      if (to.path == "/medicalAdminInstitutionJobCreation1") {
        this.keepAliveArr = defaultAddKeepArr;
      }
      if (to.path == "/medicalInstitutionJobReviseOne") {
        this.keepAliveArr = defaultDetailKeepArr;
      }
      if (to.path == "/educationAdminTalentAddOne") {
        this.keepAliveArr = defaultAddEducationKeepArr;
      }
      if (to.path == "/userEducationInstitutionsToModifyTheSchedule1") {
        this.keepAliveArr = defaultEducationKeepArr;
      }
      if (to.path == "/educationTalentAddOne") {
        this.keepAliveArr = defaultEducationTalentKeepArr;
      }
      if(to.path == "/adminTalentAdd1"){
        this.keepAliveArr = defaultAdminTalentAddKeepArr
      }
      if(to.path == "/adminPostAddPageProgressOne"){
        this.keepAliveArr = defaultAdminPostAddPageProgressKeepArr
      }
      if(to.path == "/adminJobRevise1"){
        this.keepAliveArr = defaultadminJobRevise1KeepArr
      }
      if (to.path=='/educationalInstitutionTalentRevisionProgress1') {
        this.keepAliveArr = educationalInstitutionTalentRevisionProgress
      }
      next();
    });
  },

  watch: {}
  //   created() {
  //   if (this._isMobile()) {
  //     alert("手机端");
  //     this.deviceType = "mobile";
  //   } else {
  //     alert("pc端");
  //     this.deviceType = "pc";
  //   }
  // },

  // methods: {
  //     _isMobile() {
  //           let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  //           return flag;
  //       },
  // },
};
</script>

<style>
#app {
  width: 100%;
  min-height: 100%;
  position: relative;
}
/*::-webkit-scrollbar {*/
/*  width: 0;*/
/*}*/
.main-app-css {
  display: flex;
  width: 100%;
  min-height: 100%;
  /* height: 100%; */
  /* min-width: 1366px; */
}
.navbar-app-css {
  /* height: 100vh; */
  min-height: 100vh;
  width: 266px;

  min-height: 100%;

  background: #51abff;
}
.router-view-css {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: calc(100% - 266px);
  /* min-height: 768px; */
  min-height: 100%;
  /* position: relative; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue